import {
    createVNode as _$cv,
    className as _$cn,
    createElementVNode as _$ce,
    map as _$ma,
    createUnknownComponentVNode as _$cc,
} from 'intact';
import {isInvalid, noop} from 'intact-shared';
import {getRestProps, isEmptyString} from '../utils';
import {makeStyles} from './styles';
import {FileCard} from './fileCard';


export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    const {
        getClassNameObj,
        getItemKey,
        getItemSize,
        shouldShowDelete,
        shouldShowNameTooltip,
        getItemNameTooltipProps,
        shouldLazyLoad,
        getItemLoadingVariant,
        onItemPreview,
        onItemDelete,
        onItemClick,
    } = this.list;
    
    const {
        className, items,
    } = this.get();
    const {k} = this.config;
    const isEmptySlot = (value) => {
        if (isInvalid(value) || isEmptyString(value)) return true;
        if (Array.isArray(value)) return value.every(item => isEmptySlot(item));
        if (value && value.type === 1) return isEmptySlot(value.children);
    
        return false;
    };
    const prefixSlot = $blocks.prefix ? $blocks.prefix(noop, items) : undefined;
    const suffixSlot = $blocks.suffix ? $blocks.suffix(noop, items) : undefined;
    const hasPrefixSlot = !isEmptySlot(prefixSlot);
    const hasSuffixSlot = !isEmptySlot(suffixSlot);
    const classNameObj = {
        ...getClassNameObj(),
        [className]: className,
        [makeStyles(k)]: true,
    };
    
    return _$cv('div', {
        'className': _$cn(classNameObj),
        ...getRestProps(this)
    }, [
        (hasPrefixSlot) ?
            _$ce(2, 'div', prefixSlot, 0, _$cn(`${k}-file-card-list-prefix`)) :
            undefined,
        _$ma(items, function($value, $key) {
            return _$cc(FileCard, {
                'key': getItemKey($value, $key),
                'name': $value.name,
                'type': $value.type,
                'status': $value.status,
                'src': $value.src,
                'poster': $value.poster,
                'width': $value.width,
                'height': $value.height,
                'description': $value.description,
                'errorText': $value.errorText,
                'loadingText': $value.loadingText,
                'byte': $value.byte,
                'percent': $value.percent,
                'loadingVariant': getItemLoadingVariant($value),
                'showPreview': $value.showPreview,
                'showNameTooltip': shouldShowNameTooltip($value),
                'nameTooltipProps': getItemNameTooltipProps($value),
                'showDelIcon': shouldShowDelete($value),
                'icon': $value.icon,
                'size': getItemSize($value),
                'lazy': shouldLazyLoad($value),
                'imageProps': $value.imageProps,
                'videoProps': $value.videoProps,
                'audioProps': $value.audioProps,
                'ev-click': (value, e) => onItemClick($value, value, e),
                'ev-preview': (value, e) => onItemPreview($value, value, e),
                'ev-delete': (value, e) => onItemDelete($value, value, e)
            }, getItemKey($value, $key));
        }, $this),
        (hasSuffixSlot) ?
            _$ce(2, 'div', suffixSlot, 0, _$cn(`${k}-file-card-list-suffix`)) :
            undefined
    ]);
};